/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import "./Group181.css";
import path_128_10 from "../../static/img/path-128-10@1x.png";
function Group181(props) {
  const { className } = props;

  return (
    <div className={`group-181 ${className || ""}`}>
      <img className="path-128-10" src={path_128_10} />
    </div>

  );
}

export default Group181;
